import { useFilterQueryParams, useSetFilterQueryParams } from '~/hooks/useFilter';
import Select from './Select';

type Props = {
  className?: string;
  address?: string;
};

const ObjktSortButton: React.FC<Props> = ({ className, address }) => {
  const query = useFilterQueryParams();
  const setFilterQueryParams = useSetFilterQueryParams();
  return (
    <div style={ { display: 'table' } } className={ className }>
      <Select
        value={ JSON.stringify({ [query.orderKey]: query.orderDir }) }
        onChange={
          (e) => {
            const [[orderKey, orderDir]] = Object.entries(JSON.parse(e.target.value));
            setFilterQueryParams({
              orderKey,
              orderDir,
            });
          }
        }
      >
        {
          [
            address ? {
              label: 'Recently received',
              value: { acquiredAt: 'desc' },
            } : null,
            {
              label: 'Recently minted',
              value: { id: 'desc' },
            },
            {
              label: 'Oldest',
              value: { id: 'asc' },
            },
            {
              label: 'Price: low to high',
              value: { minPrice: 'asc' },
            },
            {
              label: 'Price: high to low',
              value: { minPrice: 'desc' },
            },
            {
              label: 'Editions: low to high',
              value: { supply: 'asc' },
            },
            {
              label: 'Editions: high to low',
              value: { supply: 'desc' },
            },
          ].filter(Boolean).map(({ label, value }) => (
            <option key={ `locale-option-${JSON.stringify(value)}` } value={ JSON.stringify(value) }>
              {label}
            </option>
          ))
        }
      </Select>
    </div>
  );
};

export default ObjktSortButton;
